export default __webpack_public_path__ + "static/media/icon_acc_good_green.741ab929.svg";